import { render, staticRenderFns } from "./CmgSustainabilityErrorBox.vue?vue&type=template&id=a4b18cde&scoped=true&lang=pug&"
import script from "./cmg-sustainability-error-box.ts?vue&type=script&lang=ts&"
export * from "./cmg-sustainability-error-box.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSustainabilityErrorBox.vue?vue&type=style&index=0&id=a4b18cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b18cde",
  null
  
)

export default component.exports